<template>
  <Teleport to="body">
    <div v-for="(msgInfo, index) in messages" :key="index">
      <div class="info-reminder" :class="{ active: msgInfo.msg.includes('FA POINTS') }">
        <div class="text-center">
          <p class="mb-0" v-html="msgInfo.msg" />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import useMsg from '@global/composable/useMessage';

const { messages } = useMsg();
</script>
